import React from "react";
// import LoadingScreen from "../utils/LoadingScreen";
import Home from '../pages/home'
import Search from '../pages/search'
import My from '../pages/my'
import YetaiDetail from '../pages/yetaidetail'
import LinetaiDetail from '../pages/linetaidetail'
import Yetai from '../pages/yetai'
import Linetai from '../pages/linetai'
import DaoHang from '../pages/daohang'
import Notification from '../pages/notification'
import Layout from '../layout/index.js'
import Advice from '../pages/advice'
import { KeepAlive } from 'react-activation';

// const Loadable = (Component) => (props) =>
//     (
//         <Suspense fallback={<LoadingScreen />}>
//             <Component {...props} />
//         </Suspense>
//     );

// const MainLayout = Loadable(lazy(() => import("..layout")));
// const homepage  = Loadable(lazy(()=>import("../pages/homepage")))
// const todopage  = Loadable(lazy(()=>import("../pages/todopage")))

const routes = [
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                path: "/",
                element:<Home />,
            },
            {
                path: "/home",
                element: <Home /> ,
            },
            {
                path: "/search",
                element: <Search />,
            },

            {
                path: "/my",
                element: <My />,
            },
            {
                path: "/notification",
                element: <Notification />,
            },
            {
                path: "/yetaidetail",
                element: <YetaiDetail />,
            },
            {
                path: "/linedetail",
                element: <LinetaiDetail />,
            },
            {
                path: "/yetai",
                element: <Yetai />,
            },
            {
                path: "/linetai",
                element: <Linetai />,
            },
            {
                path: "/daohang",
                element: <DaoHang />,
            },
            {
                path: "/advice",
                element: <Advice />,
            },
        ],
    },
];

export default routes;
